<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center justify-content-between"> {{title_tab}}    
     
      <!-- <router-link :to="link_add"> -->
        <CButton color="success" @click="tambahInvoice" style="float:right" class="btn-md">Tambah</CButton>
      <!-- </router-link> -->
    
    </CCardHeader>
    <!-- Tabs -->
    
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/keanggotaan/iuran-anggota/pengaturan-iuran"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('Pengaturan  Iuran')"
          aria-controls="home"
          aria-selected="true">Pengaturan  Iurans</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keanggotaan/iuran-anggota/laporan-iuran"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('Laporan Iuran')"
          aria-controls="home"
          aria-selected="true">Laporan Iuran</router-link>
      </li>      
    </ul>

    <!-- Data Waiver-->
    <router-view></router-view>
    <!-- End Data Waiver -->
  </CCard>
</template>
<script>

export default {
  name: "Master Waiver",
  data() {
    return {
        title_tab : 'Pengaturan Iuran',
        myModal: false
    };
  },
  mounted() {
    this.mountedchange(this.$router.currentRoute.path)
  },
  watch: {
    
  },
  methods: {
      tabchange(value) {
          
          this.title_tab = value;
          switch (value) {
            case 'Pengaturan Iuran':
                this.myModal = true;
                break;
            case 'Laporan Iuran':
                // this.link_add = '/keanggotaan/iuran-anggota/laporan-iuran'
                break;            
              default:
                break;
          }
      },
      mountedchange(value) {
        switch (value) {
            case '/keanggotaan/iuran-anggota/pengaturan-iuran':
                this.title_tab = 'Penggaturan Iuran';
                break;
            case '/keanggotaan/iuran-anggota/laporan-iuran':
                this.title_tab = 'Laporan Iuran';
                break;
            default:
                break;
        }
      }
  }
};
</script>